"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var AdminCompanies_1 = require("../../../components/Pages/AdminPages/AdminCompanies/AdminCompanies");
var ListCustomers = function () {
    return React.createElement(AdminCompanies_1.default, null);
};
exports.default = ListCustomers;
